// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".camp__signup[data-v-13f62f12]{position:relative;background-image:linear-gradient(-.15rad,#165fd8 64%,transparent calc(64% + 2px))}.camp__signup__card[data-v-13f62f12]{position:relative;top:-4rem}.camp__signup__padding[data-v-13f62f12]{padding-left:16rem;padding-right:16rem}", ""]);
// Exports
module.exports = exports;
